import { render, staticRenderFns } from "./TextThresholdEdit.vue?vue&type=template&id=6ba84ab2&scoped=true"
import script from "./TextThresholdEdit.vue?vue&type=script&lang=js"
export * from "./TextThresholdEdit.vue?vue&type=script&lang=js"
import style0 from "./TextThresholdEdit.vue?vue&type=style&index=0&id=6ba84ab2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba84ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba84ab2')) {
      api.createRecord('6ba84ab2', component.options)
    } else {
      api.reload('6ba84ab2', component.options)
    }
    module.hot.accept("./TextThresholdEdit.vue?vue&type=template&id=6ba84ab2&scoped=true", function () {
      api.rerender('6ba84ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/senior/dialog/TextThresholdEdit.vue"
export default component.exports